import { FC } from 'react'
import styled from '@emotion/styled'

import { Shapes } from 'src/components/theme'
import * as atoms from 'src/v2/state/owner-reveal/activity-heatmap'
import * as orAtoms from 'src/v2/state/owner-reveal'
import { useAtom, useAtomValue } from 'jotai'
import { ActivityHeatmapMap } from 'src/v2/components/activity-heatmap-map'

const Container = styled.div`
  padding-inline: ${Shapes.spacing[4]}px;
`

export const ActivityHeatmapContent: FC = () => {
  const [selectedState, setSelectedState] = useAtom(atoms.selectedStateCode)
  const entityId = useAtomValue(orAtoms.selectedEntityId)

  const clearSelectedState = () => setSelectedState(undefined)

  if (!entityId) {
    return null
  }

  return (
    <Container>
      <ActivityHeatmapMap
        entityId={entityId}
        onClearSelection={clearSelectedState}
        stateCode={selectedState}
        onStateCodeChange={setSelectedState}
      />
    </Container>
  )
}
